<!-- Segmented control for algo filter types -->
<div
  class="bfx-segmented-group-container-sm bfx-segmented-group-container-subtle-enabled algo-filter-control"
>
  @for (item of items; track item.label){
  <button
    class="bfx-segmented-control-sm"
    [ngClass]="{
       'bfx-segmented-control-subtle-unselected-sm':value !== item.label,
       'bfx-segmented-control-subtle-selected-sm':value ===item.label
       }"
    type="button"
    (click)="setFilterState(item.label)"
  >
    <span class="label-primary">{{item.label}}</span>
  </button>
  }
</div>
